import {createUseStyles} from "react-jss";

export const useStyles = createUseStyles({
    component: {
    },
    headline: {

    },
    beforeInput: {

    },
    afterInput: {

    },
    input:{
        maxWidth: 50,
    },
    list: {

    }
})